import { BaseEntity } from "@app/models/rest/base-entity";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("ticketCompletionCodes")
export class TicketCompletionCode extends BaseEntity {
  code: string;
  description: string;
  followOnRequired: boolean;
  backgroundColor: string;
  foregroundColor: string;
}
